module.exports = __webpack_public_path__ + "static/img/cj12.9b104bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/cj12.png
// module id = 155
// module chunks = 0